import { call, put, takeLatest } from 'redux-saga/effects';
import uniqid from 'uniqid';
import { DEFAULT_ACTION } from './constants';
import { defaultAction } from './actions';
import triggerNotification from 'utils/triggerNotification';
import { NOTIFICATION } from 'common/constants';
import request from 'utils/request';
import convertErrorMsg from 'utils/convertErrorMsg';
import { readToken } from 'utils/readToken';

/*
 * @dev - best practices for handling redux action
 * @params {object} payload - handle data to pass to api
 * @params {object} metadata - handle method, properties in redux-saga
 */
export function* someFunction({ payload, metadata }) {
  // @dev - select() select redux state
  const token = readToken();

  try {
    /*
     * @dev - call()
     * Creates an Effect description that instructs the
     * middleware to  call the function fn with args as arguments.
     * data is obtained after axios call is resolved
     */
    const response = yield call(request, {
      method: 'post',
      endpoint: 'app/register', // e.g endpoint
      config: {
        headers: {
          Authorization: `Bearer ${token}`,
        },
        data: {
          ...payload,
        },
      },
    });

    // an action that display snackbar messages
    triggerNotification({
      title: 'Success!',
      type: NOTIFICATION.TYPE.SUCCESS,
    });

    // @dev - put() dispatch action to change redux state
    yield put(defaultAction.success(response.data));
  } catch (error) {
    const errorMessage = convertErrorMsg(error);
    triggerNotification({
      title: errorMessage,
      type: NOTIFICATION.TYPE.ERROR,
    });
    yield put(defaultAction.error(errorMessage));
  }
}

/**
 * Root saga manages watcher lifecycle
 */
export default function* iframe() {
  // Watches for DEFAULT_ACTION.START actions and calls someFunction when one comes in.
  // By using `takeLatest` only the result of the latest API call is applied similar to debounce
  // It returns task descriptor (just like fork) so we can continue execution
  // It will be cancelled automatically on component unmount
  yield takeLatest(DEFAULT_ACTION.START, someFunction);
}
